export function findStatusIntegracaoOxy() {
  return ({ fetch }) => ({
    type: 'STATUS_INTEGRACAO_OXY',
    payload: {
      promise: fetch('/api/status-integracoes/integrado-oxy')
    }
  });
}
